<style>
@media (min-width: 900px) {
    .fc-view-harness {
        max-height: calc(100vh - 230px) !important;
    }
}
@media (max-width: 899px) {
    .fc-view-harness {
        max-height: calc(100vh - 210px) !important;
    }
}
</style>

<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-menu :nudge-width="50" offset-y v-if="furnaces && furnaces.length > 1">
                                <v-toolbar-title slot="activator" class="d-inline-flex unselectable">
                                    <div>
                                        <span style="position: relative; bottom: -6px">{{
                                            $route.query.furnace_option ? `Furnace ${$route.query.furnace_option}` : "Select furnace"
                                        }}</span>
                                        <br />
                                        <span style="font-size: 14px; position: relative; top: -6px; font-weight: normal">{{ $t($route.meta.title) }}</span>
                                    </div>
                                    <v-icon dark>arrow_drop_down</v-icon>
                                </v-toolbar-title>

                                <v-list>
                                    <v-list-tile
                                        v-for="(item, index) in furnaces.filter((f) => f.short_code != ($route.query.furnace_option || ''))"
                                        :key="index"
                                        @click="setFurnace(item.short_code)"
                                    >
                                        <v-list-tile-title>{{ item.short_code }}</v-list-tile-title>
                                    </v-list-tile>
                                </v-list>
                            </v-menu>
                            <v-toolbar-title v-else class="d-inline-flex unselectable">
                                <div>
                                    <span style="position: relative; bottom: -6px">{{
                                        $route.query.furnace_option ? `Furnace ${$route.query.furnace_option}` : "No Active Furnace"
                                    }}</span>
                                    <br />
                                    <span style="font-size: 14px; position: relative; top: -6px; font-weight: normal">{{ $t($route.meta.title) }}</span>
                                </div>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-scan-barcode
                                v-if="hasPerm('scheduling.create') && warehouse && warehouse.length > 0"
                                ref="scan_barcode"
                                scan-object="receiving"
                                header-text="Lookup Warehouse Label"
                                @scanned="scanned_schedule.length > 0 ? setFromScan($event) : getDefaultSchedule($event, true, true, false)"
                                @closed="(scanned_schedule = []), (scanned_qty = [])"
                                @remove="removeFromSelected($event)"
                                :show-default-slot="scanned_schedule.length > 0"
                                scan-label="w"
                                :global="true"
                                :snackbar="false"
                            >
                                <template slot="button">
                                    <v-btn @mouseup.left="setInitialSchedule()" :disabled="scanned_schedule.length == 0" color="success">
                                        {{ $t("lang.continue") }}
                                    </v-btn>
                                </template>
                                <template slot-scope="props" v-if="scanned_schedule.length > 0">
                                    <vue-perfect-scrollbar
                                        class="scroll-area"
                                        :style="$bp.xs ? null : $bp.smallScreen ? 'max-height: calc(100vh - 160px)' : 'max-height: calc(90vh - 160px)'"
                                    >
                                        <v-layout
                                            row
                                            v-for="(item, index) in scanned_schedule"
                                            :key="`schedule-${index}`"
                                            class="schedule-list py-2"
                                            :class="{ 'grey lighten-3': index % 2 == 1 }"
                                        >
                                            <v-flex xs7 my-auto pl-2 pr-1>
                                                {{ item.name }}
                                                <br />
                                                {{ item.receiving_control_id }}
                                                <br />
                                                Qty: {{ item.warehouse_qty }}
                                            </v-flex>
                                            <v-flex xs3 pl-0 pr-3 my-auto>
                                                <v-text-field
                                                    v-model="scanned_qty[index]"
                                                    :label="$t('lang.qty')"
                                                    hide-details
                                                    single-line
                                                    outline
                                                    readonly
                                                    class="center-label qty-full"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs1 my-auto>
                                                <v-btn icon class="mx-0" @click="props.remove(index)">
                                                    <v-icon color="grey lighten-1" class="hover-red-icon">delete</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </vue-perfect-scrollbar>
                                </template>
                            </bc-scan-barcode>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn
                                        v-if="hasPerm('warehouse.read') && ((warehouse && warehouse.length > 0) || warehouse_dialog)"
                                        icon
                                        @mouseup.left="getWarehouse(true)"
                                    >
                                        <v-icon class="material-icons-outlined">warehouse</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t("lang.warehouse") }}
                            </bc-tooltip>
                            <bc-btn-refresh permanent @invoke-method="dbRefreshPage()"></bc-btn-refresh>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : 'py-0'">
                    <v-layout row wrap>
                        <v-flex xs12 sm3 md2 pb-0 pt-0 align-self-start>
                            <v-card class="pa-0 mt-3 mb-0" :class="$bp.xsOnly ? '' : 'mr-3'" style="height: auto; max-height: 800px">
                                <v-card-text class="pa-0">
                                    <v-layout row wrap inner-layout id="unscheduled_events">
                                        <v-flex xs12 text-center pt-3>
                                            <h2 class="mb-0">Unscheduled</h2>
                                            <v-divider class="mb-0"></v-divider>
                                        </v-flex>
                                        <vue-perfect-scrollbar
                                            v-if="(unscheduled_work_orders || []).length > 0"
                                            :key="update_unscheduled"
                                            class="scroll-area"
                                            :class="{ 'always-show-scroll': $bp.smAndDown }"
                                            :style="$bp.smAndDown ? 'max-height: 300px' : 'max-height: 700px'"
                                            style="width: 100vw !important"
                                            :settings="settings"
                                        >
                                            <v-flex
                                                xs12
                                                pa-3
                                                v-for="(order, i) in unscheduled_work_orders"
                                                :key="i"
                                                class="rounded striped-odd unselectable"
                                                :class="hasPerm('scheduling.create') ? 'cursor-move hoverable pack-event' : 'no-hover'"
                                                :data-event="prepOrderForDrag(order)"
                                                @mouseup.left="openUnscheduledEvent(order)"
                                            >
                                                <v-layout row wrap inner-layout>
                                                    <v-flex xs12 pa-0>{{ order.name }}</v-flex>
                                                    <v-flex xs12 pa-0>{{ order.customer_part_number }}</v-flex>
                                                    <v-flex xs12 fs-14 row pa-0 v-if="order.batch_count || order.batch_qty"
                                                        >{{ order.batch_count ? `${order.batch_count} Batch${order.batch_count > 1 ? "es" : ""}` : ""
                                                        }}{{ order.batch_count && order.batch_qty ? " / " : ""
                                                        }}{{ order.batch_qty ? `${order.batch_qty} Parts` : "" }}</v-flex
                                                    >
                                                    <v-flex xs12 fs-12 pa-0 v-if="order.company">{{ order.company }}</v-flex>
                                                </v-layout>
                                            </v-flex>
                                        </vue-perfect-scrollbar>
                                        <v-flex v-else xs12 pa-3 class="grey lighten-2"> No unscheduled events </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm9 md10 align-self-start pt-3>
                            <bc-calendar
                                ref="calendar"
                                :key="update_calendar"
                                :furnace="filter.furnace_option"
                                :editable="hasPerm('scheduling.update')"
                                mode="schedule"
                            ></bc-calendar>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <bc-dialog :value="warehouse_dialog" :max-width="current_part ? 800 : 1000">
                <v-card>
                    <v-card-title style="margin-bottom: 0px !important">
                        <span class="headline">{{ current_part ? $t("lang.create_batches") : $t("lang.warehouse") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeWarehouseDialog"
                            :dialog-status="warehouse_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text :class="{ 'pa-0': !current_part, 'prevent-click': !hasPerm('scheduling.create') }" style="margin: 0px !important">
                        <v-form ref="schedule" v-if="current_part" @submit.prevent>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12 sm5 align-self-start pa-0>
                                        <vue-perfect-scrollbar
                                            class="scroll-area"
                                            :style="$bp.xs ? null : this.$bp.smallScreen ? 'max-height: calc(100vh - 220px)' : 'max-height: calc(90vh - 220px)'"
                                        >
                                            <v-layout
                                                row
                                                v-for="(item, index) in schedule"
                                                :key="`schedule-${index}`"
                                                class="schedule-list py-2 clickable"
                                                :class="{ 'grey lighten-3': index % 2 == 1 }"
                                                @mouseup.left="setScheduleValue(item.warehouse_qty, index)"
                                            >
                                                <v-flex xs9 my-auto pl-2 pr-1>
                                                    {{ item.name }}
                                                    <br />
                                                    {{ item.receiving_control_id }}
                                                    <br />
                                                    Qty: {{ item.warehouse_qty }}
                                                </v-flex>
                                                <v-flex xs3 pl-0 pr-3 my-auto>
                                                    <v-text-field
                                                        v-model="schedule_qty[index]"
                                                        :label="$t('lang.qty')"
                                                        hide-details
                                                        single-line
                                                        outline
                                                        class="center-label"
                                                        :class="
                                                            +schedule_qty[index] > +schedule[index].warehouse_qty ||
                                                            (schedule_qty[index] != '' && !Number.isInteger(+schedule_qty[index])) ||
                                                            (schedule_qty[index] != '' && +schedule_qty[index] < 0)
                                                                ? 'qty-error'
                                                                : +schedule_qty[index] == +schedule[index].warehouse_qty
                                                                ? 'qty-full'
                                                                : +schedule_qty[index] > 0
                                                                ? 'qty-partial'
                                                                : null
                                                        "
                                                        :rules="ifValid([...$r.min_value(0), ...$r.max_value(item.warehouse_qty), ...$r.integer()])"
                                                        @mouseup.left.stop=""
                                                        type="number"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </vue-perfect-scrollbar>
                                        <v-flex d-inline-flex>
                                            <v-btn color="error" @mouseup.left="schedule_qty = Array(schedule.length).fill('')"> Set to zero </v-btn>
                                            <v-btn color="primary" @mouseup.left="autoFillBatches()"> Fill batches </v-btn>
                                        </v-flex>
                                    </v-flex>
                                    <v-flex xs12 sm7 align-self-start :class="{ 'pl-3 pt-2': $bp.smAndUp }">
                                        <h1>{{ current_part.name }}</h1>
                                        <h1>{{ current_part.customer_part_number }}</h1>
                                        <h1>{{ current_part.company }}</h1>
                                        <v-layout row wrap class="pt-3">
                                            <v-flex pa-0 xs8>
                                                <h3>Batch Size</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs4>
                                                <h3 class="text-center">{{ current_part.batch_size }}</h3>
                                            </v-flex>
                                            <v-flex xs8 py-0> </v-flex>
                                            <v-flex xs4 py-0>
                                                <v-divider class="mt-0"></v-divider>
                                            </v-flex>
                                            <v-flex pa-0 xs8>
                                                <h3>Total Batches</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs4>
                                                <h3 class="text-center">{{ total_batches }}</h3>
                                            </v-flex>
                                            <v-flex pa-0 xs12 mb-3>
                                                <v-divider class="my-0"></v-divider>
                                            </v-flex>
                                            <v-flex xs12 v-for="i in Object.keys(slug_group).length" :key="'station-' + i">
                                                <v-layout row>
                                                    <v-flex pa-0 xs4 my-auto>
                                                        <h4 class="mb-0">{{ filtered_group[Object.keys(filtered_group)[i - 1]][0].station }}</h4>
                                                    </v-flex>
                                                    <v-flex pa-0 xs8>
                                                        <v-select
                                                            v-model="station_options[i - 1]"
                                                            :label="$t('lang.station_id')"
                                                            :items="slug_group[filtered_group[Object.keys(filtered_group)[i - 1]][0].slug] || []"
                                                            item-value="part_station_id"
                                                            item-text="label"
                                                            class="pt-0 mb-0"
                                                            hide-details
                                                            single-line
                                                        ></v-select>
                                                    </v-flex>
                                                    <!-- {{ i }} {{ Object.keys(filtered_group) }} {{ Object.keys(filtered_group)[i-1] }} -->
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                        <v-data-table
                            v-else
                            :headers="warehouse_headers"
                            :items="warehouse"
                            :no-data-text="$t('lang.no_results_matching')"
                            hide-actions
                            :must-sort="true"
                            :pagination.sync="warehouse_default_sort"
                        >
                            <template slot="items" slot-scope="props">
                                <tr
                                    class="clickable"
                                    @mouseup.left="
                                        props.item.has_part_process_error == '1' || !props.item.furnace_options
                                            ? openPartErrorDialog(props.item)
                                            : getDefaultSchedule(props.item)
                                    "
                                >
                                    <td class="text-center">
                                        <v-icon v-if="props.item.days_aged_icon" :color="props.item.days_aged_class">{{ props.item.days_aged_icon }}</v-icon>
                                    </td>
                                    <td class="text-center">{{ props.item.days_aged }}</td>
                                    <td>{{ props.item.company }}</td>
                                    <td :class="props.item.has_part_process_error == '1' || !props.item.furnace_options ? 'red--text' : ''">
                                        {{ props.item.customer_part_number }}
                                    </td>
                                    <td>{{ props.item.name }}</td>
                                    <td class="text-center">{{ props.item.warehouse_qty }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card-text>
                    <v-card-actions v-if="current_part">
                        <v-btn color="secondary" @mouseup.left="back_to_warehouse ? (current_part = null) : openBarcode(true)">
                            <v-icon class="mr-1">keyboard_return</v-icon>
                            {{ $t("lang.back") }}
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeWarehouseDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            @mouseup.left="partial_batch > 0 ? confirmSchedule() : scheduleBatch()"
                            :disabled="station_options.includes(null || undefined) || total_batches <= 0"
                            color="success"
                        >
                            {{ $t("lang.save") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="part_process_error_dialog">
                <v-card>
                    <v-card-title class="red-dialog-title">
                        <span class="headline">Incomplete Process</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="part_process_error_dialog"
                            :dialog-status="part_process_error_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12
                                    >This part has a process that is not properly set up. To schedule this part please visit the part profile and complete the
                                    process.</v-flex
                                >
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="part_process_error_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            v-if="part_with_error"
                            color="primary"
                            @mouseup.left="$router.push({ name: 'part_profile', params: { id: part_with_error.part_id, tab: 'process' } })"
                            >Go to part</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="approve_schedule_dialog" max-width="600">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.prototype") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="approve_schedule_dialog"
                            :dialog-status="approve_schedule_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <span class="fs-22">Allow this prototype to be added to the schedule?</span>
                        <h2 class="ml-3 mt-3">{{ currApproveField("company") }}</h2>
                        <h2 class="ml-3">{{ currApproveField("customer_part_number") }}</h2>
                        <h2 class="ml-3">{{ currApproveField("name") }}</h2>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="approve_schedule_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="approveBatch()">
                            {{ $t("lang.approve") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="confirm_schedule_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ $t("lang.partial_batch") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="confirm_schedule_dialog"
                            :dialog-status="confirm_schedule_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <span class="fs-22"
                            >You are attempting to schedule
                            {{
                                Math.floor(total_batches) > 0
                                    ? Math.floor(total_batches) > 1
                                        ? `${Math.floor(total_batches)} full batches and`
                                        : "1 full batch and"
                                    : ""
                            }}
                            a partial batch that is <span style="text-decoration: underline" class="fw-bold">{{ partial_batch }}%</span> full. Are you sure you
                            want to continue?</span
                        >
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="confirm_schedule_dialog = false">{{ $t("lang.no") }}</v-btn>
                        <v-btn color="success" @mouseup.left="scheduleBatch()">
                            {{ $t("lang.yes") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import draggable from "vuedraggable";
import { Draggable } from "@fullcalendar/interaction";

import app from "Main";

export default {
    components: {
        draggable,
    },
    data() {
        return {
            part_with_error: null,
            part_process_error_dialog: false,
            disable_furnace: false,
            headers: [
                { text: this.$t("lang.customer"), sortable: false, width: "20%" },
                { text: this.$t("lang.part_number"), sortable: false, width: "15%" },
                { text: this.$t("lang.part_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.qty"), sortable: false, width: "5%", align: "center" },
                { text: this.$t("lang.date_scheduled"), sortable: false, width: "15%", align: "center" },
                { text: this.$t("lang.current_station"), sortable: false, width: "15%" },
                { text: this.$t("lang.status"), sortable: false, width: "10%" },
            ],
            warehouse_headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.aged"), value: "days_aged", width: "10%", align: "center" },
                { text: this.$t("lang.customer"), value: "company", width: "25%" },
                { text: this.$t("lang.part_number_short"), value: "customer_part_number", width: "15%" },
                { text: this.$t("lang.part_name"), value: "name", width: "30%" },
                { text: this.$t("lang.warehouse_qty"), value: "warehouse_qty", width: "15%", align: "center" },
                // { text: '', sortable: false, width: '15%' },
            ],
            warehouse_default_sort: {
                descending: true,
                sortBy: "days_aged",
                rowsPerPage: -1,
            },
            settings: {
                suppressScrollX: true,
            },
            update_unscheduled: 0,
            update_calendar: 0,
            slug_group: {},
            filtered_group: {},
            station_options: [],
            selected_wo: [],
            schedule_qty: [],
            scanned_qty: [],
            grouped_stations: {},
            current_obj: null,
            filter: {
                furnace_option: null,
                start_date: null,
            },
            start_time: null,
            start_date: null,
            current_batch: null,
            current_warehouse: null,
            current_part: null,
            back_to_warehouse: true,
            warehouse_dialog: false,
            confirm_schedule_dialog: false,
            approve_schedule_dialog: false,
            end_loader: false,
            current_approve: null,
            file_name: null,
            edit_schedule: {
                jig_tag_number: "",
                empty_box_location: "",
                lot_number: "",
                po_number: "",
            },
            scanned_schedule: [],
            temp_stations: ["setting", "pre_wash", "furnace", "post_wash", "temper"],
            printOptions: [
                { title: "documents", icon: "description", type: "print_process_sheet" },
                { title: "label", icon: "label", type: "print_4x6_label" },
            ],
            dbRefreshPage: _.debounce(this.getRefresh, 1500, { maxWait: 1500, leading: true, trailing: false }),
            furnaces: [],
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        if (!to.query.furnace_option || !to.query.start_date) {
            store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    stateProperty: "furnaces",
                    dataProperty: "machines",
                    body: { line_id: 2, slug: "furnace" },
                    commit: true,
                })
                .then((data) => {
                    if (data && data.machines && data.machines.length > 0) {
                        let start = null;
                        if (!to.query.start_date && !from.query.start_date) {
                            start =
                                new Date(
                                    new Date().toLocaleString("en-US", {
                                        timeZone: app.current_user ? app.current_user.user_time_zone : "America/New_York",
                                    })
                                ).setHours(0, 0, 0, 0) / 1000;
                        }
                        app.$router.push({
                            name: to.name,
                            query: {
                                furnace_option: to.query.furnace_option
                                    ? to.query.furnace_option
                                    : from.query.furnace_option
                                    ? from.query.furnace_option
                                    : data.machines[0].short_code,
                                start_date: to.query.start_date ? to.query.start_date : from.query.start_date ? from.query.start_date : start,
                            },
                        });
                        next((vm) => {
                            vm.furnaces = data.machines;
                            vm.finishLoader();
                        });
                    } else {
                        next((vm) => {
                            vm.$store.commit("toggleMainMenu", false);
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    }
                });
        } else {
            const unscheduled_work_orders = new Promise((resolve, reject) => {
                store
                    .dispatch("fetchWorkOrder", {
                        url: "work_orders/continuous",
                        method: "get",
                        stateProperty: "unscheduled_work_orders",
                        dataProperty: "work_orders",
                        commit: true,
                        body: { furnace_option: to.query.furnace_option, scheduled: 0 },
                    })
                    .then((data) => {
                        typeof data !== "undefined" ? resolve(data.work_orders) : reject(new Error("reject"));
                    });
            });
            store.dispatch("fetchWorkOrder", {
                url: "warehouse?line_id=2",
                method: "get",
                stateProperty: "warehouse",
                commit: true,
            });
            store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    body: { line_id: 2, slug: "furnace" },
                    dataProperty: "machines",
                    commit: true,
                })
                .then((data) => {
                    if (data && data.machines && data.machines.length > 0) {
                        next((vm) => {
                            vm.furnaces = data.machines;
                        });
                    }
                });

            Promise.all([unscheduled_work_orders])
                .then(([unscheduled_work_orders]) => {
                    // console.log(unscheduled_work_orders)
                    if (typeof unscheduled_work_orders !== "undefined") {
                        next((vm) => {
                            vm.disable_furnace = false;
                            vm.furnace_option = to.query.furnace_option;
                            vm.$store.commit("commitWorkOrder", { property: "continuous_filter.date_scheduled", with: vm.current_day });
                            vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                    store.commit("toggleLoginLoader", false);
                    store.commit("finishLoader");
                    next(false); //if any of them error, don't go to route, else set variables and proceed to route
                });
        }
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        let current_view = this.$refs.calendar.getView();
        if (
            to.query.furnace_option == from.query.furnace_option &&
            Object.keys(to.params).length == 0 &&
            to.query.start_date &&
            current_view.currentStart.getTime() / 1000 != +to.query.start_date
        ) {
            let cal_api = this.$refs.calendar.getApi();
            cal_api.gotoDate(+to.query.start_date * 1000);
        }
        if (to.query.furnace_option != from.query.furnace_option) {
            this.getUnscheduled(to.query.furnace_option);
        }
        setTimeout(() => {
            this.disable_furnace = false;
        }, 1000);
        this.setQuery(parsedQuery, this.filter, this.default_filter);
        this.finishLoader();
        next();
    },
    mounted() {
        let draggableEl = document.getElementById("unscheduled_events");
        new Draggable(draggableEl, {
            itemSelector: ".pack-event",
        });
    },
    computed: {
        ...mapState({
            rules_machines: (state) => state.validation.rules_machines,
            rules_batches: (state) => state.validation.rules_batches,
            default_filter: (state) => state.work_orders.schedule_filter,
            page: (state) => state.work_orders.page,
            machines: (state) => state.machines.machines,
            production_lines: (state) => state.production.production_lines,
            unscheduled_work_orders: (state) => state.work_orders.unscheduled_work_orders,
            warehouse: (state) => state.work_orders.warehouse,
            schedule: (state) => state.work_orders.schedule,
        }),
        axiosParams() {
            let prep_filter = {};
            prep_filter = JSON.parse(JSON.stringify(this.filter));
            if (!this.filter.furnace_option) {
                prep_filter.furnace_option = "";
            }
            return this.prepareParams(prep_filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
        currApproveField() {
            return (field) => {
                return this.current_approve && field && this.current_approve[field] ? this.current_approve[field] : "";
            };
        },
        total_qty() {
            return _.sumBy(this.schedule_qty || [], (qty) => +qty);
        },
        total_batches() {
            let total = 0;
            if (this.current_part && !!(+this.total_qty / +this.current_part.batch_size)) {
                total = Math.ceil((+this.total_qty / +this.current_part.batch_size) * 1000) / 1000;
            }
            return Math.max(total, 0);
        },
        partial_batch() {
            if (!this.current_part || !this.total_qty) return 0;
            return Math.ceil((this.total_batches * 1000) % 1000) / 10;
        },
    },
    watch: {
        "$bp.xs": function (newVal, oldVal) {
            this.update_unscheduled++;
        },
        "$bp.sm": function (newVal, oldVal) {
            this.update_unscheduled++;
        },
        "$bp.md": function (newVal, oldVal) {
            this.update_unscheduled++;
        },
    },
    methods: {
        openUnscheduledEvent(order) {
            this.$refs.calendar.openUnscheduled(order);
        },
        openApproveDialog(item) {
            this.approve_schedule_dialog = true;
            this.current_approve = item;
        },
        getRefresh() {
            this.startLoader();
            this.end_loader = true;
            this.getWarehouse(false);
            this.getWorkOrders(false);
            this.getFurnaces();
            this.getUnscheduled();
            this.$refs.calendar.refreshEvents(false);
        },
        clearShortCode() {
            this.filter.furnace_option = null;
        },
        getFurnaces() {
            this.$store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    stateProperty: "furnaces",
                    body: { line_id: 2, slug: "furnace" },
                    dataProperty: "machines",
                    commit: true,
                })
                .then((data) => {
                    if (data && data.machines && data.machines.length > 0) {
                        this.furnaces = data.machines;
                    }
                });
        },
        setFurnace(value) {
            this.filter.furnace_option = value;
            this.disable_furnace = true;
            this.filterTool(this.axiosParams, false);
        },
        scheduleBatch() {
            // alert('schedule')
            if (this.validateForm("schedule")) {
                let batches = [];
                this.schedule.forEach((s, i) => {
                    // only send if a qty is entered
                    if (!!this.schedule_qty[i] && +this.schedule_qty[i] > 0) {
                        batches.push({
                            receiving_id: s.receiving_id,
                            batch_qty: this.schedule_qty[i],
                        });
                    }
                });

                let schedule_obj = {
                    company_id: this.current_part.company_id,
                    part_id: this.current_part.part_id,
                    part_station_id: this.station_options,
                    batches: batches,
                };
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: "work_orders",
                        method: "post",
                        stateProperty: "work_orders_batches",
                        mutate: true,
                        body: schedule_obj,
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            this.getUnscheduled();
                            if (+this.current_part.warehouse_qty - this.total_qty > 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "patch",
                                    id: data.work_orders_batches[0].part_id,
                                    pk: "part_id",
                                    with: {
                                        part_id: data.work_orders_batches[0].part_id,
                                        warehouse_qty: (+this.current_part.warehouse_qty - this.total_qty).toString(),
                                        batched_qty: (+this.current_part.batched_qty + this.total_qty).toString(),
                                    },
                                });
                            } else if (+this.current_part.warehouse_qty - this.total_qty == 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "delete",
                                    id: data.work_orders_batches.part_id,
                                    pk: "part_id",
                                });
                            }
                            this.scanned_schedule = [];
                            this.scanned_qty = [];
                            this.warehouse_dialog = false;
                            this.confirm_schedule_dialog = false;
                            setTimeout(() => {
                                this.current_part = null;
                            }, 300);
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        confirmSchedule() {
            if (this.validateForm("schedule")) {
                this.confirm_schedule_dialog = true;
            }
        },
        getWorkOrders(status = true) {
            if (status) this.startLoader();
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "work_orders/batches",
                    method: "get",
                    stateProperty: "work_orders_batches",
                    commit: true,
                    body: { ...JSON.parse(JSON.stringify(this.$route.query)), line_id: 2 },
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.work_order_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    if (status) this.finishLoader();
                    if (!status && this.end_loader) {
                        this.finishLoader(true);
                        this.end_loader = false;
                    }
                });
        },
        getArrayData() {
            if (this.production_lines == null) this.getProductionLines();
        },
        getProductionLines() {
            this.$store
                .dispatch("fetchProduction", {
                    url: "production_lines",
                    method: "get",
                    stateProperty: "production_lines",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                });
        },
        closeWarehouseDialog() {
            this.warehouse_dialog = false;
            this.current_part = null;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
            this.scanned_schedule = [];
            this.scanned_qty = [];
        },
        getWarehouse(status = true) {
            if (status) {
                this.$store.commit("toggleModalLoader", true);
                this.warehouse_dialog = true;
                this.back_to_warehouse = true;
            }
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "warehouse?line_id=2",
                    method: "get",
                    stateProperty: "warehouse",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getUnscheduled(furnace = null) {
            this.$store.dispatch("fetchWorkOrder", {
                url: "work_orders/continuous",
                method: "get",
                stateProperty: "unscheduled_work_orders",
                dataProperty: "work_orders",
                commit: true,
                body: { scheduled: 0, furnace_option: furnace ? furnace : this.$route.query.furnace_option },
            });
        },
        getSchedule(part) {
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `warehouse/by_part_id/${part.part_id}/2`,
                    method: "get",
                    stateProperty: "schedule",
                    dataProperty: "parts.warehouse",
                    commit: true,
                })
                .then((data) => {
                    // console.log(data)
                    this.$refs.scan_barcode.deactivateBarcode();
                    this.$refs.scan_barcode.setLoader(false);
                    // console.log(part)
                    if (typeof data != "undefined" && data.parts && (data.parts.warehouse || []).length > 0) {
                        let scan = data.parts.warehouse.filter((w) => w.receiving_id == part.receiving_id)[0];
                        // console.log(scan)
                        if (scan) {
                            this.scanned_qty = [""];
                        } else {
                        }
                    }
                });
        },
        getDefaultSchedule(part = null, fill_batches = true, from_scan = false, to_warehouse = true) {
            if (part) {
                if (from_scan && !this.$refs.scan_barcode.barcode_dialog) this.$refs.scan_barcode.barcode_dialog = true;
                this.back_to_warehouse = to_warehouse;
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: `warehouse/by_part_id/${part.part_id}/2`,
                        method: "get",
                        stateProperty: "schedule",
                        dataProperty: "parts.warehouse",
                        commit: true,
                    })
                    .then((data) => {
                        if (typeof data != "undefined" && data.parts) {
                            this.current_part = data.parts;
                            // console.log(data)

                            if (from_scan) {
                                let found_scan = data.parts.warehouse.filter((w) => w.receiving_id == part.receiving_id)[0];
                                // console.log(found_scan)
                                this.$refs.scan_barcode.deactivateBarcode();
                                this.$refs.scan_barcode.setLoader(false);
                                if (found_scan && this.current_part.parts_stations) {
                                    this.scanned_schedule.push(found_scan);
                                    this.scanned_qty.push(+found_scan.warehouse_qty);
                                } else {
                                    this.createAlert("error", "scan_again");
                                    this.current_part = null;
                                    return;
                                }
                            }

                            this.current_warehouse = part;
                            this.grouped_stations = {};
                            this.station_options = [];
                            if (data.parts.parts_stations) {
                                this.grouped_stations = _.groupBy(data.parts.parts_stations, "sort_order");
                                let filter_group = JSON.parse(JSON.stringify(this.grouped_stations));
                                let slug_group = {};
                                for (const [key, value] of Object.entries(filter_group)) {
                                    // for (let j=0; j < value.length; j++) { if(value[j].slug == 'setting'){ value.splice(j,1) } }
                                    if (value.length == 0) {
                                        delete filter_group[key];
                                    } /* else if(value.length == 1) {
                                        this.station_options.push(value[0].part_station_id)
                                    } */ else {
                                        let group = {};
                                        if (fill_batches) {
                                            group = value.filter((e) => e.prime == "1");
                                            if (group && group.length > 0) {
                                                this.station_options.push(group[0].part_station_id);
                                            } else {
                                                this.station_options.push(value[0].part_station_id);
                                            }
                                        } else {
                                            if (value.length > 1) {
                                                let slug = value[0].slug;
                                                group = value.filter(
                                                    (e) =>
                                                        e.short_code == this.current_batch[`${slug}`] &&
                                                        e.pattern_number == this.current_batch[`${slug}_pattern`]
                                                )[0];
                                                this.station_options.push(group.part_station_id);
                                            } else {
                                                group = value[0];
                                                this.station_options.push(group.part_station_id);
                                            }
                                        }
                                        slug_group[group[0].slug] = value;
                                    }
                                }
                                this.slug_group = slug_group;
                                this.filtered_group = filter_group;
                            }
                            if (fill_batches && data.parts.warehouse) {
                                this.schedule_qty = Array(data.parts.warehouse.length).fill("");
                            }
                            // console.log(+part.warehouse_qty, +data.parts.warehouse_qty, '!=', +part.warehouse_qty != +data.parts.warehouse_qty)
                            if (fill_batches && !from_scan && +part.warehouse_qty != +data.parts.warehouse_qty) {
                                if (+data.parts.warehouse_qty == 0) {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "delete",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                    });
                                } else {
                                    this.$store.commit("mutateWorkOrder", {
                                        property: "warehouse",
                                        method: "patch",
                                        id: data.parts.part_id,
                                        pk: "part_id",
                                        with: {
                                            batched_qty: data.parts.batched_qty,
                                            warehouse_qty: data.parts.warehouse_qty,
                                            received_qty: data.parts.received_qty,
                                        },
                                    });
                                }
                            }

                            if (fill_batches && +data.parts.warehouse_qty > 0 && data.parts.batch_size) {
                                this.autoFillBatches();
                            } else {
                                this.current_part = null;
                                this.$store.commit("toggleModalLoader", false);
                            }
                            // data.parts.warehouse.forEach(w => { console.log(w) this.$store.commit('mutateWorkOrder', { property: 'schedule', with: w, method: 'post' }) })
                        }
                    })
                    .finally(() => {
                        this.$store.commit("validationOn");
                        this.$store.commit("toggleModalLoader", false);
                        if (from_scan) this.$refs.scan_barcode.activateBarcode();
                    });
            }
        },
        approveBatch() {
            if (this.currApproveField("batch_id")) {
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        pk: "batch_id",
                        id: this.currApproveField("batch_id"),
                        url: `work_orders/${this.currApproveField("work_order_id")}/batches/${this.currApproveField("batch_id")}/approve`,
                        method: "patch",
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            this.approve_schedule_dialog = false;
                            this.$store.commit("mutateWorkOrder", {
                                property: "work_orders_batches",
                                method: "patch",
                                id: data.work_orders_batch_approval.batch_id,
                                pk: "batch_id",
                                with: {
                                    approved_for_production: "1",
                                },
                            });
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        prepOrderForDrag(order) {
            return JSON.stringify(order);
        },
        openBarcode(close_warehouse = false) {
            if (close_warehouse) {
                this.warehouse_dialog = false;
            }
            this.$refs.scan_barcode.openBarcode();
        },
        setScheduleValue(qty, index) {
            this.$set(this.schedule_qty, index, qty);
        },
        autoFillBatches() {
            let curr_index = 0;
            let curr_warehouses = this.schedule.map((a) => a.warehouse_qty);
            let batch_size = +this.current_part.batch_size;
            let batches_needed = Math.floor(+this.current_part.warehouse_qty / batch_size);
            this.schedule_qty = Array(this.schedule.length).fill("");
            for (let x = 0; x < batches_needed; x++) {
                let skip = false;
                let current_batch = 0;
                for (let k = 0; k < curr_warehouses.length && !skip && current_batch < batch_size; k++) {
                    if (curr_warehouses[k] > 0) {
                        let w = curr_warehouses[k];
                        if (this.schedule_qty[curr_index] == "") this.schedule_qty[curr_index] = 0;
                        if (current_batch + +w <= batch_size) {
                            this.schedule_qty[curr_index] += +w;
                            curr_warehouses[k] = 0;
                            current_batch += +w;
                            if (this.schedule_qty[curr_index] == batch_size) {
                                skip = true;
                            }
                            curr_index++;
                        } else {
                            let num_to_pull = batch_size - current_batch;
                            current_batch += +num_to_pull;
                            this.schedule_qty[curr_index] = this.schedule_qty[curr_index] + num_to_pull;
                            curr_warehouses[k] = +w - num_to_pull;
                            if (w == 0) curr_index++;
                            skip = true;
                        }
                    }
                }
            }
            this.schedule_qty = this.schedule_qty.map(String);
        },
        setFromScan(scan) {
            // console.log(this.schedule.filter(w=>w.receiving_id == scan.receiving_id)[0])
            let found_scan = null;
            if (scan && scan.receiving_id) {
                found_scan = this.schedule.filter((w) => w.receiving_id == scan.receiving_id)[0];
                if (found_scan && this.scanned_schedule.filter((s) => s.receiving_id == scan.receiving_id).length == 0) {
                    this.scanned_schedule.push(found_scan);
                    this.scanned_qty.push(+found_scan.warehouse_qty);
                } else {
                    found_scan = null;
                }
            }
            if (!found_scan) {
                this.createAlert("error", "scan_again");
            }
            this.$refs.scan_barcode.resetBarcode();
        },
        setInitialSchedule() {
            if (this.scanned_schedule.length > 0) {
                let receive_map = this.scanned_schedule.map((s) => s.receiving_id);
                this.schedule.forEach((s, i) => {
                    if (receive_map.includes(s.receiving_id)) {
                        this.$set(this.schedule_qty, i, this.scanned_qty[receive_map.indexOf(s.receiving_id)].toString());
                    } else {
                        this.$set(this.schedule_qty, i, "");
                    }
                });
                this.warehouse_dialog = true;
                this.$refs.scan_barcode.closeBarcode(false);
            }
        },
        removeFromSelected(index) {
            this.scanned_schedule.splice(index, 1);
            this.scanned_qty.splice(index, 1);
        },
        openPartErrorDialog(part) {
            this.part_with_error = part;
            this.part_process_error_dialog = true;
        },
    },
};
</script>
